import { useQuery } from '@apollo/client';

import { AccountNotifications } from '~/components/AccountNotifications';
import ConnectorLayout from '~/components/layouts/ConnectorLayout';
import Tile from '~/images/Tiles/Enrichment.svg';
import {
  integrationTabs as objectTypes,
  readableType,
} from '~/lib/dataEnrichment';
import paths from '~/lib/paths';
import { connectorLocations } from '~/lib/segmentAnalytics';

import IntegrationTabs from '../Tabs/index';
import FieldMappingForm from './FieldMappingForm';
import query from './query.graphql';
import WebhookConfig from './WebhookConfigTab';
const EnrichmentShow = ({
  integration,
  objectType = objectTypes[integration][0].name,
}) => {
  const {
    data: { accountNotifications },
  } = useQuery(query, {
    returnPartialData: true,
    variables: {
      service: integration,
    },
  });

  const integrationObjectTypes = objectTypes[integration];
  const currentTabIndex =
    integrationObjectTypes.findIndex(
      (integrationObjectType) => integrationObjectType.name === objectType,
    ) || 0;
  // Enrichment Logs are the last tab (based on zero indexed array)
  const currentTab = integrationObjectTypes[currentTabIndex].name;
  return (
    <ConnectorLayout
      breadcrumb={[
        {
          title: 'Enrichment',
          path: paths.dataEnrichmentIndex(),
        },
      ]}
      connectorLocation={connectorLocations.enrichment}
      integration={integration}
      subtitle={`Sync Clearbit data to ${readableType(integration)}`}
      tabs={<IntegrationTabs />}
      tile={<Tile />}
    >
      <AccountNotifications
        className="mx-10 mt-6 mb-2"
        isFromEnrichmentPage
        notifications={accountNotifications}
      />
      <div className="h-full px-8">
        {renderBody(
          currentTab,
          currentTabIndex,
          integrationObjectTypes,
          integration,
        )}
      </div>
    </ConnectorLayout>
  );
};

const renderBody = (
  currentTab,
  currentTabIndex,
  integrationObjectTypes,
  integration,
) => {
  switch (currentTab) {
    case 'webhook':
      return <WebhookConfig integration={integration} />;
    default:
      return (
        <FieldMappingForm
          integration={integration}
          objectType={integrationObjectTypes[currentTabIndex]}
        />
      );
  }
};

export default EnrichmentShow;
